import { toast } from "sonner";
import { ILogin, IRegister } from "../../pages/Auth/types";
import { emailRegex } from "../../utils/helper";
import { IEmail, IPassword } from "../../pages/Profile/types";
import { t } from "i18next";
import { ICheckout, paymentMethodType } from "../../pages/Products/Cart/types";

export const registerValidation = (data: IRegister) => {
  if (data.firstName.length == 0) {
    toast.error(t("Register.validation.firstName"), { duration: Infinity });
    return false;
  }
  if (data.lastName.length == 0) {
    toast.error(t("Register.validation.lastName"), { duration: Infinity });
    return false;
  }
  if (data.japaneseFirstName.length == 0) {
    toast.error(t("Register.validation.japaneseFirstName"), { duration: Infinity });
    return false;
  }
  if (data.japaneseLastName.length == 0) {
    toast.error(t("Register.validation.japaneseLastName"), { duration: Infinity });
    return false;
  }
  if (data.postCode.length == 0) {
    toast.error(t("Register.validation.postCode"), { duration: Infinity });
    return false;
  }
  if (data.streetAddress.length == 0) {
    toast.error(t("Register.validation.streetAddress"), { duration: Infinity });
    return false;
  }
  if (data.mobileNumber.length == 0) {
    toast.error(t("Register.validation.mobileNumber"), { duration: Infinity });
    return false;
  }

  if (data.email.length == 0) {
    toast.error(t("Register.validation.emailRequired"), { duration: Infinity });
    return false;
  }
  if (data?.email?.length > 0 && !emailRegex.test(data?.email)) {
    toast.error(t("Register.validation.emailInvalid"), { duration: Infinity });
    return false;
  }
  if (data?.password?.length == 0) {
    toast.error(t("Register.validation.password"), { duration: Infinity });
    return false;
  }

  return true;
};

export const passwordValidation = (data: IPassword) => {
  if (data?.oldPassword?.length == 0) {
    toast.error(t("userProfile.password.enterOldPassword"), { duration: Infinity });
    return false;
  }

  if (data?.newPassword?.length == 0) {
    toast.error(t("userProfile.password.newPasswordError"), { duration: Infinity });
    return false;
  }

  if (data?.confirmPassword?.length == 0) {
    toast.error(t("userProfile.password.confirmPasswordError"), { duration: Infinity });
    return false;
  }

  if (data?.newPassword !== data?.confirmPassword) {
    toast.error(t("userProfile.password.passwordNotMatch"), { duration: Infinity });
    return false;
  }
  return true;
};

export const LoginValidation = (data: ILogin) => {
  if (!data.email || data.email.length === 0) {
    toast.error(t("Auth.validation.emailRequired"), { duration: Infinity });
    return false;
  }
  if (data.email.length > 0 && !emailRegex.test(data.email)) {
    toast.error(t("Auth.validation.emailInvalid"), { duration: Infinity });
    return false;
  }
  if (!data.password || data.password.length === 0) {
    toast.error(t("Auth.validation.password"), { duration: Infinity });
    return false;
  }
  return true;
};

export const retailRegisterValidation = (data: IRegister) => {
  if (data.firstName.length == 0) {
    toast.error(t("Register.validation.firstName"), { duration: Infinity });
    return false;
  }
  if (data.lastName.length == 0) {
    toast.error(t("Register.validation.lastName"), { duration: Infinity });
    return false;
  }
  if (data.japaneseFirstName.length == 0) {
    toast.error(t("Register.validation.japaneseFirstName"), { duration: Infinity });
    return false;
  }
  if (data.japaneseLastName.length == 0) {
    toast.error(t("Register.validation.japaneseLastName"), { duration: Infinity });
    return false;
  }
  if (data.postCode.length == 0) {
    toast.error(t("Register.validation.postCode"), { duration: Infinity });
    return false;
  }
  if (data.streetAddress.length == 0) {
    toast.error(t("Register.validation.streetAddress"), { duration: Infinity });
    return false;
  }
  if (!data.email || data.email.length === 0) {
    toast.error(t("Register.validation.emailRequired"), { duration: Infinity });
    return false;
  }
  if (data.email.length > 0 && !emailRegex.test(data.email)) {
    toast.error(t("Register.validation.emailInvalid"), { duration: Infinity });
    return false;
  }
  if (!data.password || data.password.length === 0) {
    toast.error(t("Register.validation.password"), { duration: Infinity });
    return false;
  }

  if (!data.confirmPassword || data.confirmPassword.length === 0) {
    toast.error(t("Register.validation.confirmPassword"), { duration: Infinity });
    return false;
  }

  if (data.password !== data.confirmPassword) {
    toast.error(t("Register.validation.confirmPasswordNotMatch"), { duration: Infinity });
    return false;
  }
  if (!data.companyName || data.companyName.length === 0) {
    toast.error(t("Register.validation.companyName"), { duration: Infinity });
    return false;
  }
  if (!data.companyName_H || data.companyName_H.length === 0) {
    toast.error(t("Register.validation.companyName_H"), { duration: Infinity });
    return false;
  }
  if (!data.prefectures || data.prefectures.length === 0) {
    toast.error(t("Register.validation.prefectures"), { duration: Infinity });
    return false;
  }
  if (!data.mobileNumber || data.mobileNumber.length === 0) {
    toast.error(t("Register.validation.mobileNumber"), { duration: Infinity });
    return false;
  }
  return true;
};

export const emailValidation = (data: IEmail) => {
  if (data.email?.length == 0) {
    toast.error(t("userProfile.emailSection.enterEmail"), { duration: Infinity });
    return false;
  }
  if (data?.email?.length > 0 && !emailRegex.test(data?.email)) {
    toast.error(t("userProfile.emailSection.validEmail"), { duration: Infinity });
    return false;
  }
  if (data?.confirmEmail?.length == 0) {
    toast.error(t("userProfile.emailSection.confirmEmail"), { duration: Infinity });
    return false;
  }
  if (data?.confirmEmail?.length > 0 && !emailRegex.test(data?.confirmEmail)) {
    toast.error(t("userProfile.emailSection.validConfirmEmail"), { duration: Infinity });
    return false;
  }
  if (data?.email !== data?.confirmEmail) {
    toast.error(t("userProfile.emailSection.emailNotMatch"), { duration: Infinity });
    return false;
  }
  return true;
};

export const CheckOutValidation = (data: ICheckout, isRetailer: boolean) => {
  if (
    !data.customerInfo.firstName ||
    data.customerInfo.firstName?.length == 0
  ) {
    toast.error(t("checkout.validation.customerInfo.firstName"), { duration: Infinity });
    return false;
  }
  if (!data.customerInfo.lastName || data.customerInfo.lastName?.length == 0) {
    toast.error(t("checkout.validation.customerInfo.lastName"), { duration: Infinity });
    return false;
  }
  if (
    !data.customerInfo.japaneseFirstName ||
    data.customerInfo.japaneseFirstName?.length == 0
  ) {
    toast.error(t("checkout.validation.customerInfo.japaneseFirstName"), { duration: Infinity });
    return false;
  }
  if (
    !data.customerInfo.japaneseLastName ||
    data.customerInfo.japaneseLastName?.length == 0
  ) {
    toast.error(t("checkout.validation.customerInfo.japaneseLastName"), { duration: Infinity });
    return false;
  }
  if (!data.customerInfo.postCode || data.customerInfo.postCode?.length == 0) {
    toast.error(t("checkout.validation.customerInfo.postCode"), { duration: Infinity });
    return false;
  }
  if (!data.customerInfo.state || data.customerInfo.state?.length == 0) {
    toast.error(t("checkout.validation.customerInfo.state"), { duration: Infinity });
    return false;
  }
  if (
    !data.customerInfo.streetAddress ||
    data.customerInfo.streetAddress?.length == 0
  ) {
    toast.error(t("checkout.validation.customerInfo.streetAddress"), { duration: Infinity });
    return false;
  }
  if (
    !data.customerInfo.mobileNumber ||
    data.customerInfo.mobileNumber?.length == 0
  ) {
    toast.error(t("checkout.validation.customerInfo.mobileNumber"), { duration: Infinity });
    return false;
  }
  if (!data.customerInfo.email || data.customerInfo.email?.length == 0) {
    toast.error(t("checkout.validation.customerInfo.email"), { duration: Infinity });
    return false;
  }
  if (isRetailer) {
    if (
      !data.customerInfo.companyName ||
      data.customerInfo.companyName?.length == 0
    ) {
      toast.error(t("checkout.validation.customerInfo.companyName"), { duration: Infinity });
      return false;
    }
    if (
      !data.customerInfo.japaneseCompanyName ||
      data.customerInfo.japaneseCompanyName?.length == 0
    ) {
      toast.error(t("checkout.validation.customerInfo.japaneseCompanyName"), { duration: Infinity });
      return false;
    }
    if (
      !data.customerInfo.department ||
      data.customerInfo.department?.length == 0
    ) {
      toast.error(t("checkout.validation.customerInfo.department"), { duration: Infinity });
      return false;
    }
  }
  if (!data.deliveryTimeSlot || data.deliveryTimeSlot?.length == 0) {
    if (data.paymentMethod !== paymentMethodType.store_payment) {
      toast.error(t("checkout.validation.deliveryTimeSlot"), { duration: Infinity });
      return false;
    }
  }

  if (data.sameAsCustomerInfo) {
    if (
      !data.shippingAddress.firstName ||
      data.shippingAddress.firstName?.length == 0
    ) {
      toast.error(t("checkout.validation.shippingAddress.firstName"), { duration: Infinity });
      return false;
    }
    if (
      !data.shippingAddress.lastName ||
      data.shippingAddress.lastName?.length == 0
    ) {
      toast.error(t("checkout.validation.shippingAddress.lastName"), { duration: Infinity });
      return false;
    }
    if (
      !data.shippingAddress.japaneseFirstName ||
      data.shippingAddress.japaneseFirstName?.length == 0
    ) {
      toast.error(t("checkout.validation.shippingAddress.japaneseFirstName"), { duration: Infinity });
      return false;
    }
    if (
      !data.shippingAddress.japaneseLastName ||
      data.shippingAddress.japaneseLastName?.length == 0
    ) {
      toast.error(t("checkout.validation.shippingAddress.japaneseLastName"), { duration: Infinity });
      return false;
    }
    if (
      !data.shippingAddress.postCode ||
      data.shippingAddress.postCode?.length == 0
    ) {
      toast.error(t("checkout.validation.shippingAddress.postCode"), { duration: Infinity });
      return false;
    }
    if (
      !data.shippingAddress.state ||
      data.shippingAddress.state?.length == 0
    ) {
      toast.error(t("checkout.validation.shippingAddress.state"), { duration: Infinity });
      return false;
    }
    if (
      !data.shippingAddress.streetAddress ||
      data.shippingAddress.streetAddress?.length == 0
    ) {
      toast.error(t("checkout.validation.shippingAddress.streetAddress"), { duration: Infinity });
      return false;
    }
    if (
      !data.shippingAddress.mobileNumber ||
      data.shippingAddress.mobileNumber?.length == 0
    ) {
      toast.error(t("checkout.validation.shippingAddress.mobileNumber"), { duration: Infinity });
      return false;
    }
    if (isRetailer) {
      if (
        !data.shippingAddress.companyName ||
        data.shippingAddress.companyName?.length == 0
      ) {
        toast.error(t("checkout.validation.shippingAddress.companyName"), { duration: Infinity });
        return false;
      }
      if (
        !data.shippingAddress.japaneseCompanyName ||
        data.shippingAddress.japaneseCompanyName?.length == 0
      ) {
        toast.error(
          t("checkout.validation.shippingAddress.japaneseCompanyName"), { duration: Infinity }
        );
        return false;
      }
      if (
        !data.shippingAddress.department ||
        data.shippingAddress.department?.length == 0
      ) {
        toast.error(t("checkout.validation.shippingAddress.department"), { duration: Infinity });
        return false;
      }
    }
  }
  return true;
};
